import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
export var CompanyIdentifier;
(function (CompanyIdentifier) {
    CompanyIdentifier["ADNZ"] = "ADNZ";
    CompanyIdentifier["PUB"] = "PUB";
})(CompanyIdentifier || (CompanyIdentifier = {}));
export var ContactRole;
(function (ContactRole) {
    ContactRole["SALES"] = "SALES";
    ContactRole["CUSTOMER"] = "CUSTOMER";
})(ContactRole || (ContactRole = {}));
export var UserSource;
(function (UserSource) {
    UserSource["ADCONSOLE"] = "ADCONSOLE";
    UserSource["SSO"] = "SSO";
})(UserSource || (UserSource = {}));
export var IdentityProviderType;
(function (IdentityProviderType) {
    IdentityProviderType["GOOGLE"] = "GOOGLE";
})(IdentityProviderType || (IdentityProviderType = {}));
export var DiscountValueType;
(function (DiscountValueType) {
    DiscountValueType["PERCENTAGE"] = "PERCENTAGE";
    DiscountValueType["AMOUNT"] = "AMOUNT";
})(DiscountValueType || (DiscountValueType = {}));
export var DiscountApplyTo;
(function (DiscountApplyTo) {
    DiscountApplyTo["GROSS1"] = "GROSS1";
    DiscountApplyTo["GROSS2"] = "GROSS2";
    DiscountApplyTo["GROSS3"] = "GROSS3";
    DiscountApplyTo["NET1"] = "NET1";
    DiscountApplyTo["NET2"] = "NET2";
    DiscountApplyTo["NET3"] = "NET3";
})(DiscountApplyTo || (DiscountApplyTo = {}));
export var DiscountOperationType;
(function (DiscountOperationType) {
    DiscountOperationType["DISCOUNT"] = "DISCOUNT";
    DiscountOperationType["SURCHARGE"] = "SURCHARGE";
})(DiscountOperationType || (DiscountOperationType = {}));
export var UserRole;
(function (UserRole) {
    UserRole["ADMIN"] = "ADMIN";
    UserRole["USER_ADMIN"] = "USER_ADMIN";
    UserRole["COMPANY_ADMIN"] = "COMPANY_ADMIN";
    UserRole["USER"] = "USER";
})(UserRole || (UserRole = {}));
export var Role;
(function (Role) {
    Role["ADVERTISER"] = "ADVERTISER";
    Role["AGENCY"] = "AGENCY";
    Role["BROKER"] = "BROKER";
    Role["OTHER"] = "OTHER";
    Role["PUBLISHER"] = "PUBLISHER";
})(Role || (Role = {}));
export var EmailPlaceholder;
(function (EmailPlaceholder) {
    EmailPlaceholder["USER_EMAIL"] = "USER_EMAIL";
    EmailPlaceholder["SALES_CONTACT_EMAIL"] = "SALES_CONTACT_EMAIL";
    EmailPlaceholder["CREATOR_EMAIL"] = "CREATOR_EMAIL";
    EmailPlaceholder["ASSIGNEE_EMAIL"] = "ASSIGNEE_EMAIL";
    EmailPlaceholder["CONTACT_EMAIL"] = "CONTACT_EMAIL";
    EmailPlaceholder["RECEIVERS"] = "RECEIVERS";
    EmailPlaceholder["COMPANY_GENERAL_EMAIL"] = "COMPANY_GENERAL_EMAIL";
    EmailPlaceholder["ADMANAGEMENT_IF_BOOKED_OR_SELFBOOKED"] = "ADMANAGEMENT_IF_BOOKED_OR_SELFBOOKED";
    EmailPlaceholder["PUBLIC_COMMENT_RECEIVER"] = "PUBLIC_COMMENT_RECEIVER";
    EmailPlaceholder["CAMPAIGN_INVOICE_EMAILS"] = "CAMPAIGN_INVOICE_EMAILS";
    EmailPlaceholder["CAMPAIGN_COMMUNICATION_EMAIL"] = "CAMPAIGN_COMMUNICATION_EMAIL";
    EmailPlaceholder["CAMPAIGN_SCREENSHOT_EMAILS"] = "CAMPAIGN_SCREENSHOT_EMAILS";
    EmailPlaceholder["CAMPAIGN_CREATIVE_EMAILS"] = "CAMPAIGN_CREATIVE_EMAILS";
    EmailPlaceholder["CAMPAIGN_REPORT_EMAILS"] = "CAMPAIGN_REPORT_EMAILS";
    EmailPlaceholder["CAMPAIGN_SALES"] = "CAMPAIGN_SALES";
    EmailPlaceholder["CAMPAIGN_CREATOR"] = "CAMPAIGN_CREATOR";
    EmailPlaceholder["INVOICE_EMAILS"] = "INVOICE_EMAILS";
})(EmailPlaceholder || (EmailPlaceholder = {}));
export var Placeholder;
(function (Placeholder) {
    Placeholder["COMPANY_NAME"] = "COMPANY_NAME";
    Placeholder["CAMPAIGN_LINK"] = "CAMPAIGN_LINK";
    Placeholder["CAMPAIGN_NAME"] = "CAMPAIGN_NAME";
    Placeholder["INTERNAL_ORDER_NUMBER"] = "INTERNAL_ORDER_NUMBER";
    Placeholder["SALES_UNIT_NAME"] = "SALES_UNIT_NAME";
    Placeholder["CAMPAIGN_POSITIONS"] = "CAMPAIGN_POSITIONS";
    Placeholder["ATTACHMENT_LINKS"] = "ATTACHMENT_LINKS";
    Placeholder["MESSAGE"] = "MESSAGE";
    Placeholder["ATTACHMENT_LIST"] = "ATTACHMENT_LIST";
    Placeholder["CREATOR_NAME"] = "CREATOR_NAME";
    Placeholder["INVOICE_NUMBER"] = "INVOICE_NUMBER";
    Placeholder["SCREENSHOTS_ARCHIVE_LINK"] = "SCREENSHOTS_ARCHIVE_LINK";
    Placeholder["ACCOUNT"] = "ACCOUNT";
    Placeholder["CREATIVE_PREVIEW_LINKS"] = "CREATIVE_PREVIEW_LINKS";
    Placeholder["REFERENCE_NUMBER"] = "REFERENCE_NUMBER";
    Placeholder["CUSTOMER_NAME"] = "CUSTOMER_NAME";
    Placeholder["CAMPAIGN_SALES_NAME"] = "CAMPAIGN_SALES_NAME";
    Placeholder["TASK_TOPIC"] = "TASK_TOPIC";
})(Placeholder || (Placeholder = {}));
export var MailTemplateType;
(function (MailTemplateType) {
    MailTemplateType["SEND_INVOICE"] = "SEND_INVOICE";
    MailTemplateType["SEND_INVOICE_CANCELLATION"] = "SEND_INVOICE_CANCELLATION";
    MailTemplateType["PAYMENT_REMINDER_1"] = "PAYMENT_REMINDER_1";
    MailTemplateType["PARTIALLY_PAID_PAYMENT_REMINDER_1"] = "PARTIALLY_PAID_PAYMENT_REMINDER_1";
    MailTemplateType["PAYMENT_REMINDER_2"] = "PAYMENT_REMINDER_2";
    MailTemplateType["PARTIALLY_PAID_PAYMENT_REMINDER_2"] = "PARTIALLY_PAID_PAYMENT_REMINDER_2";
    MailTemplateType["PAYMENT_REMINDER_3"] = "PAYMENT_REMINDER_3";
    MailTemplateType["PARTIALLY_PAID_PAYMENT_REMINDER_3"] = "PARTIALLY_PAID_PAYMENT_REMINDER_3";
    MailTemplateType["PAYMENT_PERSONAL_CALL_REMINDER"] = "PAYMENT_PERSONAL_CALL_REMINDER";
    MailTemplateType["PARTIALLY_PAID_PAYMENT_PERSONAL_CALL_REMINDER"] = "PARTIALLY_PAID_PAYMENT_PERSONAL_CALL_REMINDER";
    MailTemplateType["SEND_SCREENSHOTS"] = "SEND_SCREENSHOTS";
    MailTemplateType["SEND_POSITIONS_SCREENSHOTS"] = "SEND_POSITIONS_SCREENSHOTS";
    MailTemplateType["REQUEST_CREATIVES"] = "REQUEST_CREATIVES";
    MailTemplateType["SEND_REPORT"] = "SEND_REPORT";
    MailTemplateType["SEND_END_CAMPAIGN_REPORT"] = "SEND_END_CAMPAIGN_REPORT";
    MailTemplateType["SEND_STATE_READY"] = "SEND_STATE_READY";
    MailTemplateType["SEND_UNDERDELIVERED_REPORT"] = "SEND_UNDERDELIVERED_REPORT";
    MailTemplateType["COMMENT"] = "COMMENT";
    MailTemplateType["REPORTING_TOOL_MAIL"] = "REPORTING_TOOL_MAIL";
    MailTemplateType["OPS_CAMPAIGN_DECLINED"] = "OPS_CAMPAIGN_DECLINED";
    MailTemplateType["POSITION_EXCLUDED"] = "POSITION_EXCLUDED";
    MailTemplateType["PAYOUT_REPORT"] = "PAYOUT_REPORT";
    MailTemplateType["ACCOUNT_EXCLUDED"] = "ACCOUNT_EXCLUDED";
    MailTemplateType["OFFER_NOTIFICATION"] = "OFFER_NOTIFICATION";
    MailTemplateType["SELF_BOOKING_CAMPAIGN_ACTIVATED"] = "SELF_BOOKING_CAMPAIGN_ACTIVATED";
    MailTemplateType["CREDIT_CARD_PAYMENT_SUCCESSFUL"] = "CREDIT_CARD_PAYMENT_SUCCESSFUL";
    MailTemplateType["CREDIT_CARD_PAYMENT_FAILED"] = "CREDIT_CARD_PAYMENT_FAILED";
    MailTemplateType["SELFBOOKING_GREETING"] = "SELFBOOKING_GREETING";
    MailTemplateType["SELFBOOKING_SEND_REMINDER"] = "SELFBOOKING_SEND_REMINDER";
    MailTemplateType["SELFBOOKING_SEND_OVERDUE"] = "SELFBOOKING_SEND_OVERDUE";
    MailTemplateType["SELFBOOKING_ORDER_CONFIRMATION"] = "SELFBOOKING_ORDER_CONFIRMATION";
    MailTemplateType["SELFBOOKING_CAMPAIGN_UNDERDELIVERY"] = "SELFBOOKING_CAMPAIGN_UNDERDELIVERY";
    MailTemplateType["SELFBOOKING_CAMPAIGN_FINISHED"] = "SELFBOOKING_CAMPAIGN_FINISHED";
    MailTemplateType["INVITATION"] = "INVITATION";
    MailTemplateType["RESTORE_PASSWORD"] = "RESTORE_PASSWORD";
    MailTemplateType["SEND_ORDER"] = "SEND_ORDER";
    MailTemplateType["SEND_OFFER"] = "SEND_OFFER";
    MailTemplateType["SEND_PRINT_PROOFS"] = "SEND_PRINT_PROOFS";
    MailTemplateType["OFFER_REJECTED"] = "OFFER_REJECTED";
    MailTemplateType["OFFER_EXPIRED"] = "OFFER_EXPIRED";
    MailTemplateType["FUNNEL_TASK_ASSIGNED_NOTIFICATION"] = "FUNNEL_TASK_ASSIGNED_NOTIFICATION";
    MailTemplateType["FUNNEL_DECLINED_TASK_SNOOZING_NOTIFICATION"] = "FUNNEL_DECLINED_TASK_SNOOZING_NOTIFICATION";
    MailTemplateType["FUNNEL_TASK_UNSNOOZED_NOTIFICATION"] = "FUNNEL_TASK_UNSNOOZED_NOTIFICATION";
    MailTemplateType["SECOND_FACTOR_CONFIRMATION"] = "SECOND_FACTOR_CONFIRMATION";
    MailTemplateType["REQUEST_ANALOG_CREATIVES"] = "REQUEST_ANALOG_CREATIVES";
    MailTemplateType["POST_DIGITAL_CONFIRMATION_NOTIFICATION"] = "POST_DIGITAL_CONFIRMATION_NOTIFICATION";
    MailTemplateType["POST_DIGITAL_CANCELLATION_NOTIFICATION"] = "POST_DIGITAL_CANCELLATION_NOTIFICATION";
    MailTemplateType["DRAFT_CREATIVE_NOTIFICATION"] = "DRAFT_CREATIVE_NOTIFICATION";
    MailTemplateType["CREATIVE_DEACTIVATED_NOTIFICATION"] = "CREATIVE_DEACTIVATED_NOTIFICATION";
    MailTemplateType["NO_GENERATIONS_DETECTED_ALERT"] = "NO_GENERATIONS_DETECTED_ALERT";
    MailTemplateType["BOUNCE"] = "BOUNCE";
    MailTemplateType["TICKET_STATUS_CHANGE_NOTIFICATION"] = "TICKET_STATUS_CHANGE_NOTIFICATION";
    MailTemplateType["TICKET_ASSIGNEE_CHANGE_NOTIFICATION"] = "TICKET_ASSIGNEE_CHANGE_NOTIFICATION";
    MailTemplateType["TICKET_COMMENT_NOTIFICATION"] = "TICKET_COMMENT_NOTIFICATION";
    MailTemplateType["MANUAL_DISPATCH_NOTIFICATION"] = "MANUAL_DISPATCH_NOTIFICATION";
})(MailTemplateType || (MailTemplateType = {}));
export var ClientMailTemplateType;
(function (ClientMailTemplateType) {
    ClientMailTemplateType["SEND_INVOICE"] = "SEND_INVOICE";
    ClientMailTemplateType["PAYMENT_REMINDER_1"] = "PAYMENT_REMINDER_1";
    ClientMailTemplateType["PARTIALLY_PAID_PAYMENT_REMINDER_1"] = "PARTIALLY_PAID_PAYMENT_REMINDER_1";
    ClientMailTemplateType["PAYMENT_REMINDER_2"] = "PAYMENT_REMINDER_2";
    ClientMailTemplateType["PARTIALLY_PAYMENT_REMINDER_2"] = "PARTIALLY_PAYMENT_REMINDER_2";
    ClientMailTemplateType["PAYMENT_REMINDER_3"] = "PAYMENT_REMINDER_3";
    ClientMailTemplateType["PARTIALLY_PAYMENT_REMINDER_3"] = "PARTIALLY_PAYMENT_REMINDER_3";
    ClientMailTemplateType["PAYMENT_PERSONAL_CALL_REMINDER"] = "PAYMENT_PERSONAL_CALL_REMINDER";
    ClientMailTemplateType["PARTIALLY_PAYMENT_PERSONAL_CALL_REMINDER"] = "PARTIALLY_PAYMENT_PERSONAL_CALL_REMINDER";
    ClientMailTemplateType["SEND_SCREENSHOTS"] = "SEND_SCREENSHOTS";
    ClientMailTemplateType["REQUEST_CREATIVES"] = "REQUEST_CREATIVES";
    ClientMailTemplateType["SEND_REPORT"] = "SEND_REPORT";
    ClientMailTemplateType["SEND_END_CAMPAIGN_REPORT"] = "SEND_END_CAMPAIGN_REPORT";
    ClientMailTemplateType["SEND_STATE_READY"] = "SEND_STATE_READY";
    ClientMailTemplateType["SEND_UNDERDELIVERED_REPORT"] = "SEND_UNDERDELIVERED_REPORT";
    ClientMailTemplateType["COMMENT"] = "COMMENT";
    ClientMailTemplateType["REPORTING_TOOL_MAIL"] = "REPORTING_TOOL_MAIL";
    ClientMailTemplateType["FUNNEL_TASK_ASSIGNED_NOTIFICATION"] = "FUNNEL_TASK_ASSIGNED_NOTIFICATION";
    ClientMailTemplateType["FUNNEL_DECLINED_TASK_SNOOZING_NOTIFICATION"] = "FUNNEL_DECLINED_TASK_SNOOZING_NOTIFICATION";
})(ClientMailTemplateType || (ClientMailTemplateType = {}));
export var LanguageCode;
(function (LanguageCode) {
    LanguageCode["DE"] = "DE";
    LanguageCode["EN"] = "EN";
    LanguageCode["FR"] = "FR";
    LanguageCode["IT"] = "IT";
})(LanguageCode || (LanguageCode = {}));
export var TrafficSource;
(function (TrafficSource) {
    TrafficSource["GOOGLE"] = "GOOGLE";
    TrafficSource["FACEBOOK"] = "FACEBOOK";
    TrafficSource["LINKEDIN"] = "LINKEDIN";
    TrafficSource["CHATGPT"] = "CHATGPT";
})(TrafficSource || (TrafficSource = {}));
/** Console UI language, used only by preferredLanguages. DE is Swiss German (DE-CH), the base German of the platform; DE_AT and DE_DE are UI-only variants with optional own texts in ws-translate. Content and communication languages (mails, documents, contacts) stay LanguageCode. */
export var UiLanguage;
(function (UiLanguage) {
    UiLanguage["DE"] = "DE";
    UiLanguage["DE_AT"] = "DE_AT";
    UiLanguage["DE_DE"] = "DE_DE";
    UiLanguage["EN"] = "EN";
    UiLanguage["FR"] = "FR";
    UiLanguage["IT"] = "IT";
})(UiLanguage || (UiLanguage = {}));
export var TemporaryAccessPinStatus;
(function (TemporaryAccessPinStatus) {
    TemporaryAccessPinStatus["PENDING"] = "PENDING";
    TemporaryAccessPinStatus["USED"] = "USED";
    TemporaryAccessPinStatus["EXPIRED"] = "EXPIRED";
})(TemporaryAccessPinStatus || (TemporaryAccessPinStatus = {}));
export var OidcIssuerName;
(function (OidcIssuerName) {
    OidcIssuerName["SWISS_POST"] = "SWISS_POST";
    OidcIssuerName["COOP"] = "COOP";
})(OidcIssuerName || (OidcIssuerName = {}));
export var PrintOperationExportType;
(function (PrintOperationExportType) {
    PrintOperationExportType["TOPAS"] = "TOPAS";
    PrintOperationExportType["CICLON"] = "CICLON";
    PrintOperationExportType["COOP"] = "COOP";
    PrintOperationExportType["NONE"] = "NONE";
})(PrintOperationExportType || (PrintOperationExportType = {}));
export var PrintCreativeExportType;
(function (PrintCreativeExportType) {
    PrintCreativeExportType["ONEVISION"] = "ONEVISION";
})(PrintCreativeExportType || (PrintCreativeExportType = {}));
export var SocialNetworkType;
(function (SocialNetworkType) {
    SocialNetworkType["FACEBOOK"] = "FACEBOOK";
    SocialNetworkType["INSTAGRAM"] = "INSTAGRAM";
    SocialNetworkType["LINKEDIN"] = "LINKEDIN";
    SocialNetworkType["X"] = "X";
})(SocialNetworkType || (SocialNetworkType = {}));
export var ExternalReferenceType;
(function (ExternalReferenceType) {
    ExternalReferenceType["STRING"] = "STRING";
    ExternalReferenceType["NUMERIC"] = "NUMERIC";
})(ExternalReferenceType || (ExternalReferenceType = {}));
export var UiTheme;
(function (UiTheme) {
    UiTheme["DARK"] = "DARK";
    UiTheme["LIGHT"] = "LIGHT";
    UiTheme["SYSTEM"] = "SYSTEM";
})(UiTheme || (UiTheme = {}));
